import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-faq-area',
  templateUrl: './faq-area.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './faq-area.component.scss'
})


export class FaqAreaComponent {
  @Input() title : string = "";

  @Input() questions1 : string = "";
  @Input() answers1 : string = "";
  @Input() link1 : string = "";

  @Input() questions2 : string = "";
  @Input() answers2 : string = "";
  @Input() link2 : string = "";

  @Input() questions3 : string = "";
  @Input() answers3 : string = "";
  @Input() link3 : string = "";

  @Input() questions4 : string = "";
  @Input() answers4 : string = "";
  @Input() link4 : string = "";

  @Input() questions5 : string = "";
  @Input() answers5 : string = "";
  @Input() link5 : string = "";

  @Input() questions6 : string = "";
  @Input() answers6 : string = "";
  @Input() link6 : string = "";
}
